import { Skeleton } from '~/components/ui/skeleton/Skeleton';

/**
 * A page or panel of form fields while its record loads: a label bar over a field bar, in the
 * same two-column grid the form uses, so nothing jumps when the real fields arrive (DESIGN.md §11.1).
 */
export function SkeletonFields({ fields = 6 }: { fields?: number }) {
  return (
    <div
      role="status"
      aria-busy="true"
      className="grid grid-cols-1 gap-6 lg:grid-cols-2"
      data-testid="skeleton-fields"
    >
      <span className="sr-only">Loading…</span>
      {Array.from({ length: fields }, (_, index) => (
        <div key={index} className="space-y-2">
          <Skeleton className="w-24" />
          <Skeleton className="h-11" />
        </div>
      ))}
    </div>
  );
}
